<div class="pwa-header">
  <ion-buttons
    class="pwa-header__buttons-start"
    [ngClass]="{ 'mapfre-hide': !(auth.getState$() | async).isLogged || (menu.processActive | async) }"
  >
    <ion-menu-button mode="md"> </ion-menu-button>
  </ion-buttons>
  <ion-buttons>
    <ion-button
      class="pwa-header__logo margin-logo"
      [ngClass]="{
        'margin-logo-with-subtitle':
          (patrimonialService.origin$ | async) !== 'METS' &&
          (patrimonialService.isPublicPatrimonialProcess$ | async)
      }"
      [disabled]="ctx.currentPage==='/client-area/home'"
      (click)="nav.root('client-area/home')"
    >
      <img src="assets/images/mapfre-logo.svg" alt="Logo Mapfre" />
    </ion-button>
  </ion-buttons>
  <div
    class="pwa-header__subtitle"
    *ngIf="
      (patrimonialService.origin$ | async) !== 'METS' &&
      (patrimonialService.isPublicPatrimonialProcess$ | async)
    "
  >
    <div class="dark mapfre-fs-xs">
      {{ 'PWA_PATRIMONIALS.HEADER.TITLE' | translate }}
    </div>
  </div>

  <ion-buttons
    class="pwa-header__buttons-end"
    [ngClass]="{ 'mapfre-hide': !(auth.getState$() | async).isLogged || (menu.processActive | async) }"
  >
    <ion-button
      [ngClass]="{ selected: myProductsSelected$ | async }"
      color="primary"
      mode="md"
      color="medium"
      (click)="nav.root('client-area/home')"
    >
      <ion-label>{{ 'CORE.MENU.MY_PRODUCTS' | translate }}</ion-label>
    </ion-button>
    <ion-button
      *ngIf="this.auth.checkUserIsParticular()"
      [ngClass]="{ selected: inFamilySelected$ | async }"
      mode="md"
      color="medium"
      (click)="onOpenFamilies()"
    >
      <ion-label>{{ 'CORE.MENU.MY_FAMILY' | translate }}</ion-label>
    </ion-button>

    <ion-button
      *ngIf="this.auth.checkUserIsParticular()"
      [ngClass]="{ selected: paymentPlanSelected$ | async }"
      mode="md"
      color="medium"
      (click)="nav.root('payment-plan')"
    >
      <ion-label>{{ 'CORE.MENU.PAYMENT_PLAN' | translate }}</ion-label>
    </ion-button>

    <ion-button
      *ngIf="this.auth.checkUserIsCompany() && (paymentPlanService.showPaymentPlanAccessOnHomePage$ | async)"
      [ngClass]="{ selected: paymentPlanSelected$ | async }"
      mode="md"
      color="medium"
      (click)="nav.root('payment-plan')"
    >
      <ion-label>{{ 'CORE.MENU.PAYMENT_PLAN' | translate }}</ion-label>
    </ion-button>

    <div class="pwa-header__separator"></div>
    <ng-container *ngIf="teCuidamos.getState$() | async as teCuidamosUserData">
      <ion-button
        *ngIf="isAllowed(teCuidamosUserData.memberState)"
        [ngClass]="{ selected: tecuidamosSelected$ | async }"
        mode="md"
        color="medium"
        class="t-inherit"
        style="margin-right: 33px"
        (click)="onNavToTeCuidamos(teCuidamosUserData.memberState)"
      >
        <ion-label>
          {{
            this.auth.checkUserIsParticular()
              ? ('CORE.MENU.TECUIDAMOS' | translate)
              : ('CORE.MENU.TECUIDAMOS_BUSINESS' | translate)
          }}
        </ion-label>
      </ion-button>
    </ng-container>

    <ion-button
      (click)="onProfile($event)"
      class="pwa-header__avatar-button"
      mode="md"
      color="medium"
    >
      <div class="avatar">
        <div class="avatar__label">{{ userShorthandAvatar }}</div>
        <div
          *ngIf="menu.unreadMails$ | async"
          class="avatar__notification"
        ></div>
      </div>
      <img
        class="pwa-header__avatar-arrow"
        [ngClass]="{
          'pwa-header__avatar-arrow--rotate': profileExpanded$ | async
        }"
        src="assets/images/show-more-grey.svg"
        alt="Show arrow"
      />
    </ion-button>
  </ion-buttons>
</div>
